import { MODULE_NAME as CREATIVE_LIBRARY_MODULE } from 'modules/creative-library/config/routes';
import { ID, TITLE } from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { availableColumnDefinitions } from './columnDefinitions';
import { CREATIVE_LIBRARY_REPORT_ID } from './creativeLibraryReportId';
import { defaultColumns, customColumns } from './reportPresets';

export const creativeLibraryReportConfig = {
    id: CREATIVE_LIBRARY_REPORT_ID,
    label: 'Creative Library',
    module: CREATIVE_LIBRARY_MODULE,
    endpoint: 'creative-library/list',
    rowIdField: ID.field,
    columnsDef: availableColumnDefinitions,
    searchPlaceholderMsgId: 'app.reports.byCreative.search.placeholder',
    searchField: TITLE.field,
    sortMap: {
        [ID.field]: 'itemId',
    },
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    rowHeight: 62,
    comfortableRowHeight: 112,
};
